// 开发服
// let baseUrl = 'http://192.168.0.17:8067'
// let geoUrl = 'http://192.168.0.17:8080'
// 正式服
// let baseUrl = 'https://api.certifarm.cn'
// let geoUrl = 'https://gis.certifarm.cn'

// 以上地址为本地开发调试使用，提交代码时务必注释以上代码
let baseUrl = process.env.envConfig.API_URL
let geoUrl = process.env.envConfig.GEO_URL
export { baseUrl, geoUrl }
